import { createRouter, createWebHistory } from 'vue-router'

import AuswertungLand from './components/Auswertung_Land.vue'
import AuswertungUser from './components/Auswertung_User.vue'
import AuswertungKommentar from './components/Auswertung_Kommentar.vue'
import AuswertungGesamtsieger from './components/Auswertung_Gesamtsieger.vue'
import AuswertungDetail from './components/Auswertung_Detail.vue'
import AuswertungLandMW from './components/Auswertung_Land_MW.vue'
import HelloWorld from './components/HelloWorld.vue'
import Signin from './components/auth/Signin.vue'

const routes = [
  { path: '/', component: HelloWorld },
  { path: '/signin', component: Signin },
  { path: '/auswertung/gesamtsieger', component: AuswertungGesamtsieger },
  { path: '/auswertung/:auswertung', component: AuswertungLand, props: true },
  { path: '/auswertung/detail/:land', component: AuswertungDetail, props: true },
  { path: '/auswertung/:auswertung/:spezial', component: AuswertungLandMW, props: true },
  { path: '/userauswertung/:auswertung', component: AuswertungUser, props: true },
  { path: '/kommentarauswertung', component: AuswertungKommentar },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
